/**
 * Busca flexível na listagem de produtos do ERP.
 * Tokens + stopwords: "CADEIRA DE RODAS" encontra "CADEIRA RODAS".
 */

const STOP_WORDS = new Set([
  'a', 'as', 'o', 'os',
  'de', 'da', 'do', 'das', 'dos',
  'e', 'em', 'no', 'na', 'nos', 'nas',
  'para', 'por', 'com', 'sem',
  'um', 'uma', 'uns', 'umas',
  'the', 'of', 'and'
])

export function normalizeSearchText(value) {
  return String(value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

function stemToken(token) {
  if (token.length <= 3) return token
  if (token.endsWith('oes') && token.length > 5) return `${token.slice(0, -3)}ao`
  if (token.endsWith('aes') && token.length > 5) return `${token.slice(0, -3)}ao`
  if (token.endsWith('s') && token.length > 4) return token.slice(0, -1)
  return token
}

export function tokenizeQuery(query) {
  const normalized = normalizeSearchText(query)
  if (!normalized) return []

  const tokens = []
  for (const part of normalized.split(' ').filter(Boolean)) {
    if (STOP_WORDS.has(part)) continue
    const stemmed = stemToken(part)
    if (stemmed.length >= 2) tokens.push(stemmed)
  }
  return [...new Set(tokens)]
}

/**
 * Retorna true se o produto casa com a busca.
 * - SKU / barcode: substring completa (sem tokenizar)
 * - Nome: todos os tokens significativos devem aparecer (AND)
 */
export function matchesProductSearch(product, query) {
  const q = String(query ?? '').trim()
  if (!q) return true

  const qNorm = normalizeSearchText(q)
  const sku = normalizeSearchText(product?.sku)
  const barcode = normalizeSearchText(product?.barcode)

  if (sku && sku.includes(qNorm)) return true
  if (barcode && barcode.includes(qNorm)) return true

  const name = normalizeSearchText(product?.name)
  if (!name) return false

  // Frase inteira ainda funciona quando for substring contígua
  if (name.includes(qNorm)) return true

  const tokens = tokenizeQuery(q)
  if (tokens.length === 0) return name.includes(qNorm)

  return tokens.every((token) => name.includes(token))
}

export function matchesProductBrand(product, brand) {
  if (!brand) return true
  if (product?.brand_id != null && String(product.brand_id) === String(brand.id)) {
    return true
  }
  const productBrand = normalizeSearchText(product?.brand_name || product?.brand)
  const selected = normalizeSearchText(brand.name)
  return Boolean(productBrand && selected && productBrand === selected)
}
